import React from 'react';
import { Mic, MicOff, MonitorUp, PhoneOff, Video, VideoOff } from 'lucide-react';

const baseButtonClassName = 'inline-flex h-12 w-12 items-center justify-center rounded-full border transition disabled:cursor-not-allowed disabled:opacity-60';

const MediaControls = ({
  microphoneEnabled,
  cameraEnabled,
  screenShareEnabled,
  screenShareSupported,
  busy = false,
  onToggleMicrophone,
  onToggleCamera,
  onToggleScreenShare,
  onLeave,
}) => (
  <div className="flex flex-wrap items-center justify-center gap-3">
    <button
      type="button"
      onClick={onToggleMicrophone}
      disabled={busy}
      className={`${baseButtonClassName} ${
        microphoneEnabled
          ? 'border-slate-200 bg-white text-slate-700 hover:bg-slate-50'
          : 'border-rose-200 bg-rose-50 text-rose-700 hover:bg-rose-100'
      }`}
      title={microphoneEnabled ? 'Mute microphone' : 'Unmute microphone'}
    >
      {microphoneEnabled ? <Mic className="h-5 w-5" /> : <MicOff className="h-5 w-5" />}
    </button>

    <button
      type="button"
      onClick={onToggleCamera}
      disabled={busy}
      className={`${baseButtonClassName} ${
        cameraEnabled
          ? 'border-slate-200 bg-white text-slate-700 hover:bg-slate-50'
          : 'border-amber-200 bg-amber-50 text-amber-700 hover:bg-amber-100'
      }`}
      title={cameraEnabled ? 'Turn camera off' : 'Turn camera on'}
    >
      {cameraEnabled ? <Video className="h-5 w-5" /> : <VideoOff className="h-5 w-5" />}
    </button>

    {screenShareSupported && onToggleScreenShare ? (
      <button
        type="button"
        onClick={onToggleScreenShare}
        disabled={busy}
        className={`${baseButtonClassName} ${
          screenShareEnabled
            ? 'border-sky-200 bg-sky-50 text-sky-700 hover:bg-sky-100'
            : 'border-slate-200 bg-white text-slate-700 hover:bg-slate-50'
        }`}
        title={screenShareEnabled ? 'Stop screen sharing' : 'Share screen'}
      >
        <MonitorUp className="h-5 w-5" />
      </button>
    ) : null}

    <button
      type="button"
      onClick={onLeave}
      className={`${baseButtonClassName} border-rose-200 bg-rose-600 text-white hover:bg-rose-700`}
      title="Leave call"
    >
      <PhoneOff className="h-5 w-5" />
    </button>
  </div>
);

export default MediaControls;
